// extracted by mini-css-extract-plugin
export default {"notification-button":"notifications-button_notification-button__ILBO0"};